/** Осталось ли меньше одного экрана до низа — момент догрузить следующую страницу.
 *
 * Порог в один экран, а не в фиксированные пиксели: страница успевает приехать
 * до того, как пользователь упрётся в конец списка, независимо от высоты
 * контейнера (узкий popover и грид пикера на весь диалог ведут себя одинаково).
 */
export function nearBottom(el: HTMLElement): boolean {
    return el.scrollHeight - el.scrollTop - el.clientHeight < el.clientHeight;
}
